module.exports = __webpack_public_path__ + "static/puppeteer-a6f73af654b4488d301800ae5e6c3e52.svg";